export default __webpack_public_path__ + "static/r-90-4-08daa19a284bd1050febf9ed1e368c39.jpg";